module.exports = __webpack_public_path__ + "img/pop_zhuanxiang@2x.f8a1585f.png";